/**
 * U.S. ZIP code (5 or 9 digits). Keep in sync with Portal-Backend/services/usZipValidation.js
 */

export function extractZipDigits(raw: unknown): string {
  return String(raw ?? "").replace(/\D/g, "");
}

export type UsZipValidationResult =
  | { ok: true; normalized: string }
  | { ok: false; message: string };

export function validateUsZip(raw: unknown): UsZipValidationResult {
  const digits = extractZipDigits(raw);

  if (digits.length !== 5 && digits.length !== 9) {
    return {
      ok: false,
      message: "Enter a valid U.S. ZIP code (5 or 9 digits).",
    };
  }

  const normalized =
    digits.length === 5
      ? digits
      : `${digits.slice(0, 5)}-${digits.slice(5)}`;

  return { ok: true, normalized };
}
